/*
  The foot of every page (round 45): sections/vr-footer.liquid, assets/vr-footer.css.
  The lists of links fold away under their names on phones and stand open in columns on wider screens; one band of
  light passes over the gold logo when the niche comes into view; the root behind the page turns to the night in
  the lower half of the page, so a bounce past the foot shows the footer's night; the thanks after subscribing.
*/
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var narrow = window.matchMedia('(max-width: 749.98px)');
  var ease = 'cubic-bezier(0.22, 0.61, 0.36, 1)';
  var each = function (list, fn) { Array.prototype.forEach.call(list, fn); };
  var SPEED = 30; /* pixels a second for the mastheads, one slow pace whatever their number */

  /* ---- the extent of the ink of a masthead's file, measured once for each file (as on the press page) ---- */
  var inks = {};
  function ink(url, done) {
    var c = inks[url];
    if (c) { if (c.ready) done(c.v); else c.q.push(done); return; }
    c = inks[url] = { ready: false, v: null, q: [done] };
    var finish = function (v) { c.ready = true; c.v = v; c.q.forEach(function (f) { f(v); }); c.q = []; };
    var im = new Image();
    im.crossOrigin = 'anonymous';
    im.onload = function () {
      try {
        if (!im.naturalWidth || !im.naturalHeight) { finish(null); return; }
        var W = 320, H = Math.max(1, Math.round(W * im.naturalHeight / im.naturalWidth));
        var cv = document.createElement('canvas'); cv.width = W; cv.height = H;
        var g = cv.getContext('2d'); g.drawImage(im, 0, 0, W, H);
        var d = g.getImageData(0, 0, W, H).data;
        var x0 = W, y0 = H, x1 = -1, y1 = -1;
        for (var y = 0; y < H; y++) for (var x = 0; x < W; x++) { if (d[(y * W + x) * 4 + 3] > 40) { if (x < x0) x0 = x; if (x > x1) x1 = x; if (y < y0) y0 = y; if (y > y1) y1 = y; } }
        if (x1 < 0) { finish(null); return; }
        var fw = (x1 + 1 - x0) / W, fh = (y1 + 1 - y0) / H, fx = x0 / W, fy = y0 / H;
        finish({
          ar: (fw * im.naturalWidth) / (fh * im.naturalHeight),
          size: (100 / fw).toFixed(2) + '% ' + (100 / fh).toFixed(2) + '%',
          pos: (fw >= 0.999 ? 50 : fx / (1 - fw) * 100).toFixed(2) + '% ' + (fh >= 0.999 ? 50 : fy / (1 - fh) * 100).toFixed(2) + '%'
        });
      } catch (e) { finish(null); /* a file the canvas may not read: shown whole in its box */ }
    };
    im.onerror = function () { finish(null); };
    im.src = url;
  }
  function masts(root) {
    var track = root.querySelector('.vrf-press__track');
    if (!track) return;
    var pace = function () {
      var set = track.querySelector('.vrf-press__set');
      if (set && set.offsetWidth > 0) track.style.setProperty('--vrf-drift', Math.max(24, set.offsetWidth / SPEED).toFixed(1) + 's');
    };
    var spans = root.querySelectorAll('[data-vrf-mast]');
    var left = spans.length;
    each(spans, function (el) {
      ink(el.getAttribute('data-vrf-mast'), function (v) {
        if (v) {
          el.style.setProperty('--ink-ar', v.ar.toFixed(4));
          el.style.setProperty('--ink-size', v.size);
          el.style.setProperty('--ink-pos', v.pos);
          el.style.setProperty('--ink-boost', Math.min(1.46, Math.max(0.74, Math.sqrt(3 / v.ar))).toFixed(3));
          el.classList.add('is-measured');
        }
        left -= 1;
        if (left === 0) pace();
      });
    });
    pace();
    var rt = 0;
    window.addEventListener('resize', function () { window.clearTimeout(rt); rt = window.setTimeout(pace, 200); });
  }

  function init(root) {
    if (!root || root.getAttribute('data-vrf-ready')) return;
    root.setAttribute('data-vrf-ready', '1');

    /* ---- the mastheads are measured as the foot comes near (each file is read on a canvas, which takes a moment
       that is better not spent while the page is loading), and drift only while the foot is near ---- */
    var press = root.querySelector('.vrf-press');
    if (press && 'IntersectionObserver' in window) {
      var measured = false;
      new IntersectionObserver(function (entries) {
        var near = entries.some(function (e) { return e.isIntersecting; });
        root.classList.toggle('is-near', near);
        if (near && !measured) { measured = true; masts(root); }
      }, { rootMargin: '900px 0px 900px 0px' }).observe(press);
    } else {
      root.classList.add('is-near');
      masts(root);
    }

    /* ---- the lists: folded on phones, open columns elsewhere ---- */
    var groups = root.querySelectorAll('.vrf-group');
    var mode = function () {
      each(groups, function (g) {
        var head = g.querySelector('summary');
        if (narrow.matches) { g.open = false; if (head) head.removeAttribute('tabindex'); }
        else { g.open = true; if (head) head.setAttribute('tabindex', '-1'); }
      });
    };
    each(groups, function (g) {
      var head = g.querySelector('summary');
      var body = g.querySelector('.vrf-group__body');
      if (!head || !body) return;
      head.addEventListener('click', function (e) {
        if (!narrow.matches) { e.preventDefault(); return; }
        if (reduce || !body.animate) return;
        e.preventDefault();
        if (g.open) {
          var h = body.offsetHeight;
          var a = body.animate([{ height: h + 'px' }, { height: '0px' }], { duration: 450, easing: ease });
          a.onfinish = function () { g.open = false; };
        } else {
          g.open = true;
          var h2 = body.offsetHeight;
          body.animate([{ height: '0px' }, { height: h2 + 'px' }], { duration: 450, easing: ease });
        }
      });
    });
    mode();
    if (narrow.addEventListener) narrow.addEventListener('change', mode); else if (narrow.addListener) narrow.addListener(mode);

    /* ---- one band of light over the logo as the niche comes into view ---- */
    var arch = root.querySelector('.vrf-arch');
    if (arch && !reduce && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting) { root.classList.add('is-in'); io.disconnect(); } });
      }, { rootMargin: '0px 0px -18% 0px' });
      io.observe(arch);
    }

    /* ---- the thanks after subscribing ---- */
    var dialog = root.querySelector('.vrf-modal');
    if (dialog && typeof dialog.showModal === 'function') {
      var done = root.querySelector('[id^="VrfLettersDone-"]');
      try {
        dialog.showModal();
        if (done) done.hidden = true;
        var close = function () { dialog.close(); };
        var btn = dialog.querySelector('[data-vrf-close]');
        if (btn) btn.addEventListener('click', close);
        dialog.addEventListener('click', function (e) { if (e.target === dialog) close(); });
        dialog.addEventListener('close', function () {
          try { var u = new URL(window.location.href); u.searchParams.delete('customer_posted'); u.hash = ''; window.history.replaceState(null, '', u.toString()); } catch (err) {}
        });
      } catch (err) {}
    }
  }

  /* ---- the root behind the page: the night below the middle of the page ---- */
  function ends() {
    var html = document.documentElement;
    var mark = function () { html.classList.toggle('vr-foot-night', (window.scrollY || window.pageYOffset) > (html.scrollHeight - window.innerHeight) / 2); };
    window.addEventListener('scroll', mark, { passive: true });
    window.addEventListener('resize', mark);
    mark();
  }

  function start() {
    each(document.querySelectorAll('[data-vrf]'), init);
    ends();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  document.addEventListener('shopify:section:load', function (e) { init(e.target.querySelector('[data-vrf]')); });
})();
